function reportingSelect2Options(element, { multiple = false } = {}) {
  const placeholder = element.querySelector("option[value='']")?.textContent || "None";

  return {
    width: "100%",
    allowClear: !multiple,
    placeholder: placeholder,
    minimumResultsForSearch: multiple ? 0 : 6,
    dropdownCssClass: "rmm-select2-dropdown",
    multiple: multiple
  };
}

function bindReportingSelect2ClearBehavior($el) {
  $el.off(".reportingSelect2Clear");
  $el.on("select2:unselecting.reportingSelect2Clear select2:clearing.reportingSelect2Clear", function () {
    jQuery(this).data("skipNextOpen", true);
  });

  $el.on("select2:opening.reportingSelect2Clear", function (event) {
    if (jQuery(this).data("skipNextOpen")) {
      jQuery(this).removeData("skipNextOpen");
      event.preventDefault();
    }
  });

  $el.on("select2:unselect.reportingSelect2Clear select2:clear.reportingSelect2Clear", function () {
    jQuery(this).select2("close");
  });
}

export function destroySelect2Element(element) {
  if (!element || !window.jQuery) return;

  const $el = jQuery(element);

  try {
    if ($el.data("select2")) {
      $el.select2("destroy");
    }
  } catch (_error) {
    // Select2 can throw if the instance is half torn down after Turbolinks cache restore.
  }

  const orphanContainer = element.nextElementSibling;
  if (orphanContainer && orphanContainer.classList.contains("select2-container")) {
    orphanContainer.remove();
  }

  element.classList.remove("select2-hidden-accessible");
  element.removeAttribute("data-select2-id");
  element.removeAttribute("aria-hidden");
  element.removeAttribute("tabindex");
}

export function destroyAllSelect2In(scope = document) {
  if (!window.jQuery) return;

  const root = scope && scope.querySelectorAll ? scope : document;
  root.querySelectorAll("select").forEach(destroySelect2Element);

  // Drop detached dropdown panels appended to <body>.
  document.querySelectorAll("body > .select2-container.select2-container--open").forEach((node) => {
    node.remove();
  });
}

function initSelect2Element(element, options) {
  const $el = jQuery(element);
  destroySelect2Element(element);
  $el.select2(options);
  return $el;
}

export function initializeReportingSelect2(ids = [], multipleIds = []) {
  ids.forEach(function (id) {
    const element = document.getElementById(id);
    if (!element || !window.jQuery) return;

    if (id === "tags") {
      initSelect2Element(element, {
        tags: true,
        width: "100%",
        tokenSeparators: [","],
        placeholder: "Add your tags here",
        selectOnClose: true,
        closeOnSelect: false,
        dropdownCssClass: "rmm-select2-dropdown"
      });
      return;
    }

    const $el = initSelect2Element(element, reportingSelect2Options(element));
    bindReportingSelect2ClearBehavior($el);
  });

  multipleIds.forEach(function (id) {
    const element = document.getElementById(id);
    if (!element || !window.jQuery) return;
    initSelect2Element(element, reportingSelect2Options(element, { multiple: true }));
  });
}

window.initializeReportingSelect2 = initializeReportingSelect2;
window.destroyAllSelect2In = destroyAllSelect2In;
window.destroySelect2Element = destroySelect2Element;

export default function initializeSelect2ForElements({ ids = [], classes = [] } = {}) {
  ids.forEach((selector) => {
    const element = document.querySelector(`#${selector}`);
    if (!element) return;

    const inReportingFilters = element.closest(".reporting-filters");

    if (selector === "tags") {
      initSelect2Element(element, {
        tags: true,
        width: "100%",
        tokenSeparators: [","],
        placeholder: "Add your tags here",
        selectOnClose: true,
        closeOnSelect: false,
        dropdownCssClass: inReportingFilters ? "rmm-select2-dropdown" : undefined
      });
    } else if (selector === "order_status" || selector === "status") {
      initSelect2Element(
        element,
        inReportingFilters
          ? reportingSelect2Options(element, { multiple: true })
          : { multiple: true, width: "100%" }
      );
    } else if (inReportingFilters) {
      const $el = initSelect2Element(
        element,
        reportingSelect2Options(element, { multiple: element.multiple })
      );
      if (!element.multiple) bindReportingSelect2ClearBehavior($el);
    } else {
      initSelect2Element(element, { width: "100%" });
    }
  });

  classes.forEach((className) => {
    document.querySelectorAll(`.${className}`).forEach((element) => {
      if (className === "tracking_url") {
        initSelect2Element(element, {
          tags: true,
          createTag: function (params) {
            return {
              id: params.term,
              text: params.term,
              newOption: true
            };
          },
          templateResult: function (data) {
            if (data.newOption) {
              return jQuery("<span>" + data.text + " (New)</span>");
            }

            return data.text;
          }
        });
      } else {
        initSelect2Element(element, { width: "100%" });
      }
    });
  });
}

function initRegionSelects(scope = document) {
  jQuery(scope).find(".region").not(".rmm-region").each(function () {
    initSelect2Element(this, {
      width: "100%",
      placeholder: "Select Region",
      allowClear: true,
      dropdownCssClass: "rmm-select2-dropdown"
    });
  });
}

jQuery(document)
  .off("cocoon:after-insert.select2Regions")
  .on("cocoon:after-insert.select2Regions", function (_event, insertedItem) {
    initRegionSelects(insertedItem);
  });

document.addEventListener("turbolinks:before-cache", function () {
  destroyAllSelect2In(document);

  if (!window.jQuery) return;

  jQuery(".range, .shipping_date_range, [id*='date_range']").each(function () {
    const $input = jQuery(this);
    if ($input.data("daterangepicker")) {
      $input.data("daterangepicker").remove();
      $input.removeData("daterangepicker");
    }
  });

  jQuery("body > .daterangepicker").remove();
});

document.addEventListener("turbolinks:load", function () {
  initRegionSelects(document);
});
